import React, { useEffect, useState } from "react";
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import {
  getLocalStorage,
  setLocalStorage,
  toggleInArray,
} from "utils/generalUtils";
import { useNavigate } from "react-router-dom";
import { sidebarMenuItems } from "utils/data";
import clsx from "clsx";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import "../../Sass/Auth.scss";

const useStyle = makeStyles((theme) => ({
  rsMenuItem: {
    padding: "0px !important",
    fontSize: "16px",

    "& .MuiListItemIcon-root": {
      minWidth: "auto",
      marginLeft: "8px !important",
      marginRight: "22px",
      height: "24px",
    },
    "& .MuiListItemText-root": {
      "&>p>span": {
        background: `${theme.palette.secondary.main}10`,
        border: `0.5px solid${theme.palette.secondary.main}50`,
        borderRadius: "2px",
        padding: "1px 8px",
        marginLeft: "10px",
      },
    },
  },
  rsActiveMenuItem: {
    background: `${theme.palette.primary.main}20 !important`,
  },
  selectedMenuIcon: {
    "&>path": {
      stroke: `${theme.palette.primary.main}`,
      fill: `${theme.palette.primary.main}`,
    },
    "&>rect": {
      stroke: `${theme.palette.primary.main}`,
      fill: `${theme.palette.primary.main}`,
    },
    "&>g": {
      "&>path": {
        stroke: `${theme.palette.primary.main}`,
        fill: `${theme.palette.primary.main}`,
      },
    },
  },
}));

function SideBarMenuItem({
  loginUserDetail,
  open,
  welcomeDialog,
  setWelcomeDialog,
}) {
  const classes = useStyle();
  const navigate = useNavigate();
  const [openDrawerItems, setOpenDrawerItems] = useState([]);
  const currentPath = window.location.pathname;
  // const [selectedIndex, setSelectedIndex] = useState(currentPath);

  /** Handle Click Sidebar Menu Change */
  const handleSideBarMenuClick = (e, item) => {

    // DONT DELETE THE FOLLOWING COMMENT ---- Open Welcome Dialog Condtion ---- 

    // if (
    //   // item.url !== "/order" &&
    //   // item.url !== "/patients" &&
    //   loginUserDetail?.data?.data?.role !== "admin" &&
    //   loginUserDetail?.data?.data?.role !== "super_admin" && 
    //   loginUserDetail?.data?.data?.is_new_user === true &&
    //   loginUserDetail?.data?.data?.pharmacy_detail !== null &&
    //   loginUserDetail?.data?.data?.pharmacy_detail !== undefined 
    // ) {
    //   if (
    //     loginUserDetail?.data?.data?.pharmacy_detail?.tour
    //       ?.t_is_watch_introduction_video &&
    //     loginUserDetail?.data?.data?.pharmacy_detail?.tour
    //       ?.t_is_import_patient_pmr &&
    //     loginUserDetail?.data?.data?.pharmacy_detail?.tour?.t_is_create_order
    //   ) {
    //     setWelcomeDialog(false);
    //   } else {
    //     setWelcomeDialog(true);
    //   }
    // }
    e.preventDefault();
    e.stopPropagation();
    if (item?.sub?.length > 0) {
      setOpenDrawerItems([...toggleInArray(openDrawerItems, item?.key)]);
    } else {
      if (item?.url === "/order") {
        setLocalStorage("refreshRepeatOrderListOnReturn", "true");
        if (window.location.pathname === "/order" && !window.location.search) {
          // window.location.reload();
        } else {
          navigate(item?.url);
        }
      } else {
        navigate(item?.url);
      }
      // setSelectedIndex(item?.key);
    }
  };

  /** Set Current Path  In Local Storage */
  useEffect(() => {
    if (currentPath != "/order") {
      setLocalStorage("searchString", "");
      setLocalStorage("todayOrder", false);
      setLocalStorage("surgeryList", {});
      setLocalStorage("groupList", {});
    }
    if (currentPath != "/rx-collection" && currentPath != "/prescription-tracking") {
      // setLocalStorage("chaseUp", false);
    }
  }, [currentPath]);

  /** SideBar set based on path useffect */
  useEffect(() => {
    const selectedMenu = sidebarMenuItems.filter((item) => {
      if (item.hasOwnProperty("sub")) {
        let selectedSubMenu = item.sub.filter((subItem) => {
          return subItem.url === currentPath;
        });
        if (selectedSubMenu.length > 0) {
          return selectedSubMenu;
        }
      } else {
        return item.url === currentPath;
      }
    });
    // if (selectedMenu.length > 0) {
    //   setSelectedIndex(selectedMenu[0]?.key);
    // }
  }, []);

  /** Render SideBar Menu List */
  const renderMenuItem = (menuItem) => {
    let permitToUse = false;
    if (loginUserDetail?.data?.data?.role === "admin") {
      if (menuItem.key === "payment_list") {
      } else {
        permitToUse = true;
      }
    } else {
      permitToUse = menuItem.hasOwnProperty("permission")
        ? menuItem?.permission[loginUserDetail?.data?.data?.role] === 1
        : false;
    }
    if (
      "Activity Log" != menuItem.value &&
      "Payment Log" != menuItem.value &&
      "Duplicate Patient" != menuItem.value &&
      "How To?" != menuItem.value
    ) {
      return (
        <>
          <ListItem
            sx={{ display: "block" }}
            to={menuItem?.url}
            onClick={(e) => handleSideBarMenuClick(e, menuItem)}
            className={`${classes.rsMenuItem} NavMenuList`}
          >
            {permitToUse ? (
              <ListItemButton
                className={clsx(
                  currentPath == menuItem?.url && classes.rsActiveMenuItem
                )}
              >
                {menuItem?.icon && (
                  <ListItemIcon className="SideMenuIcon">
                    <PrimaryIcon
                      className={
                        currentPath == menuItem?.url && classes.selectedMenuIcon
                      }
                      color={
                        currentPath == menuItem?.url ? "primary" : "secondary"
                      }
                      icon={menuItem?.icon}
                      width="22px"
                      height="22px"
                    />
                  </ListItemIcon>
                )}
                {open && (
                  <ListItemText>
                    <Typography
                      color={
                        currentPath == menuItem?.url ? "primary" : "secondary"
                      }
                    >
                      {menuItem?.value}
                      {menuItem?.notificationCount && (
                        <span> {menuItem?.notificationCount} </span>
                      )}
                    </Typography>
                  </ListItemText>
                )}
              </ListItemButton>
            ) : null}
          </ListItem>
        </>
      );
    }
  };

  return (
    <>
      {sidebarMenuItems.map((item, index) => {
        return renderMenuItem(item);
      })}
    </>
  );
}

export default SideBarMenuItem;
